export const lheWorks = {
  movie: [
    {
      id: 1,
      title: '크로스',
      year: '2024',
      image: require('./movie/1. 크로스.jpeg')
    },
    {
      id: 2,
      title: '점프,점프,점프',
      year: '2022', 
      image: require('./movie/2. 점프,점프,점프.jpeg')
    },
    {
      id: 3,
      title: '도굴',
      year: '2020',
      image: require('./movie/3. 도굴.jpeg')
    },
    {
      id: 4,
      title: '얼굴없는 보스',
      year: '2019',
      image: require('./movie/4. 얼굴없는 보스.jpeg')
    },
    {
      id: 5,
      title: '어린 의뢰인',
      year: '2019',
      image: require('./movie/5. 어린 의뢰인.jpg')
    },
    {
      id: 6,
      title: '강철비',
      year: '2017',
      image: require('./movie/6. 강철비.jpeg')
    },
    {
      id: 7,
      title: '우주의 크리스마스',
      year: '2016',
      image: require('./movie/7. 우주의 크리스마스.jpeg')
    },
    {
      id: 8,
      title: '덕혜옹주',
      year: '2016',
      image: require('./movie/8. 덕혜옹주.jpeg')
    },
    {
      id: 9,
      title: '용의자X',
      year: '2012',
      image: require('./movie/9. 용의자X.jpeg')
    },
  ],
  drama: [
    {
      id: 1,
      title: '재벌X형사',
      year: '2024',
      image: require('./drama/1. 재벌X형사.jpg')
    },
    {
      id: 2,
      title: '로얄로더',
      year: '2024',
      image: require('./drama/2. 로얄로더.jpg')
    },
    {
      id: 3,
      title: '재벌집 막내아들',
      year: '2022',
      image: require('./drama/3. 재벌집 막내아들.jpg')
    },
    {
      id: 4,
      title: '연예인 매니저로 살아남기',
      year: '2022',
      image: require('./drama/4. 연예인 매니저로 살아남기.jpg')
    },
    {
      id: 5,
      title: '꽃 피면 달 생각하고',
      year: '2021',
      image: require('./drama/5. 꽃 피면 달 생각하고.jpg')
    },
    {
      id: 6,
      title: '오월의 청춘',
      year: '2021',
      image: require('./drama/6. 오월의 청춘.jpg')
    },
    {
      id: 7,
      title: '미스 몬테크리스토',
      year: '2021',
      image: require('./drama/7. 미스 몬테크리스토.jpg')
    },
    {
      id: 8,
      title: '런온',
      year: '2020',
      image: require('./drama/8. 런온.jpg')
    },
    {
      id: 9,
      title: '그놈이 그놈이다',
      year: '2020',
      image: require('./drama/9. 그놈이 그놈이다.jpg')
    },
  ],
};